$(function () {
    // @ vars ----------------------------------------------
    const div_overlay = document.querySelector('.plo__dialog-overlay')
    const links_read_more = document.querySelectorAll('.plo__read-more')
    const links_read_less = document.querySelectorAll('.plo__read-less')
    const dlg_btn_close = document.querySelector('.plo__dialog .btn-close')
    const dlg_body = document.querySelector('.plo__dialog .plo__dialog-body')
    const class_visible = 'plo__dialog-overlay--is-visible'

    if (div_overlay === null) {
        return
    }

    // @ funcs -----------------------------------------------
    const dlgOpen = () => {
        document.body.classList.add(class_visible)
        div_overlay.classList.add(class_visible)
    }

    const dlgClose = () => {
        document.body.classList.remove(class_visible)
        div_overlay.classList.remove(class_visible)
    }

    // @ events ----------------------------------------------
    links_read_more.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault()
            const card = link.closest('.plo__card')
            const content = card.querySelector('.plo__content')
            dlg_body.innerHTML = content.innerHTML
            dlgOpen()
        })
    })

    links_read_less.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault()
            dlgClose()
        })
    })

    div_overlay.addEventListener('click', (e) => {
        dlgClose()
    })

    dlg_btn_close.addEventListener('click', (e) => {
        dlgClose()
    })

    dlg_body.addEventListener('click', (e) => {
        e.stopPropagation()
    })

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            dlgClose()
        }
    })

    // @ inits ----------------------------------------------
    // dlgOpen()
})
